document.addEventListener('DOMContentLoaded', () => {

  // — Fade-in on scroll —
  const items = [...document.querySelectorAll('[data-fade]')];
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: .08, rootMargin: '0px 0px -40px 0px' });
  items.forEach(el => {
    const siblings = el.parentElement ? [...el.parentElement.querySelectorAll('[data-fade]')] : [];
    const idx = siblings.indexOf(el);
    el.style.transitionDelay = idx > 0 ? `${idx * 0.1}s` : '0s';
    io.observe(el);
  });

  // — Hide native Shopify buy on external product —
  const productPage = document.querySelector('[data-has-external-buy="true"]');
  if (productPage) {
    document.querySelectorAll('.shopify-payment-button, .shopify-payment-button__button, .shopify-product-form').forEach(el => {
      if (!el.closest('.product-purchase-area') || !el.classList.contains('ff-affiliate-button')) {
        el.style.display = 'none';
      }
    });
  }

  // — Product thumbnail switcher —
  const mainMedia = document.getElementById('ff-main-media');
  const thumbs    = document.querySelectorAll('.product-thumb[data-full]');
  if (mainMedia && thumbs.length) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const full  = thumb.getAttribute('data-full');
        const alt   = thumb.getAttribute('data-alt') || '';
        const type  = thumb.getAttribute('data-type');
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (type === 'embed') {
          mainMedia.innerHTML = `<iframe src="${full}" title="${alt}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width:100%;aspect-ratio:16/9;border-radius:24px;border:1px solid rgba(227,89,43,.12);"></iframe>`;
        } else if (type === 'video') {
          mainMedia.innerHTML = `<video src="${full}" controls style="width:100%;aspect-ratio:16/9;border-radius:24px;"></video>`;
        } else {
          mainMedia.innerHTML = `<img src="${full}" alt="${alt}" style="width:100%;height:auto;object-fit:contain;display:block;border-radius:24px;border:1px solid rgba(227,89,43,.12);">`;
        }
      });
    });
  }

  // — Animated button ripple —
  document.querySelectorAll('.button, .ff-buy-button').forEach(btn => {
    btn.addEventListener('click', function(e) {
      const circle = document.createElement('span');
      const rect = this.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height) * 2;
      circle.style.cssText = `position:absolute;width:${size}px;height:${size}px;left:${e.clientX-rect.left-size/2}px;top:${e.clientY-rect.top-size/2}px;background:rgba(255,255,255,.15);border-radius:50%;transform:scale(0);animation:ripple .6s linear;pointer-events:none;`;
      if (!document.querySelector('#ff-ripple-style')) {
        const s = document.createElement('style');
        s.id = 'ff-ripple-style';
        s.textContent = '@keyframes ripple{to{transform:scale(1);opacity:0}}';
        document.head.appendChild(s);
      }
      this.appendChild(circle);
      setTimeout(() => circle.remove(), 650);
    });
  });

});
